const images = $( '.lazyload' );

if ( images.length > 0 ) {
    require( 'lazyload' );

    images.lazyload( {
        effect: 'fadeIn'
    } );
}
